import React from 'react';
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';
import { Link } from "react-scroll";
import { useTranslation } from "react-i18next";

const CoTabThree = () => {
    const { t } = useTranslation('community');
    const dataList2 = [
        {
            image: t('lePlan.donations.imgSrc'),
        }
    ]
    const dataList4 = [
        {
            image: t('lePlan.epargneSalariale.imgSrc'),
        }
    ]
    const dataList5 = [
        {
            image: t('lePlan.gestionPrimes.imgSrc'),
        }
    ]
    return (
        <div>
            <div className="row">
                    <div className="col-lg-12">
                        <Tabs>
                            <div className="row row--30 align-items-center">
                                <div className="col-lg-4">
                                    <div className="rn-default-tab style-three">
                                        <div className="tab-button-panel">
                                            <TabList className="tab-button">
                                                <Tab>
                                                    <div className="rn-tab-button text-center">
                                                        <button>{t('lePlan.donations.subtitle')}</button>
                                                    </div>   
                                                </Tab>
                                                <Tab>
                                                    <div className="rn-tab-button text-center">
                                                        <button>{t('lePlan.epargneSalariale.subtitle')}</button>
                                                    </div>   
                                                </Tab>
                                                <Tab>
                                                    <div className="rn-tab-button text-center">
                                                        <button>{t('lePlan.gestionPrimes.subtitle')}</button>
                                                    </div>   
                                                </Tab>
                                            </TabList>
                                        </div>
                                    </div>
                                </div>
                                <div className='col-lg-8'>    
                                    <div className="rn-default-tab style-three">
                                        <div className="tab-content-panel">
                                            
                                            <TabPanel>
                                                <div className="rn-tab-content">
                                                    <div className="inner">
                                                        <div className="row align-items-center row--30">
                                                            <div className="col-lg-6">
                                                                <div className="section-title">
                                                                    <h4 className="title">{t('lePlan.donations.title')}</h4>
                                                                    <p>{t('lePlan.donations.content')}</p>
                                                                    <div className="read-more d-flex">
                                                                        <Link className="btn-default btn-small mr-2 co-btn" to="contactform" smooth={true} offset={-70} duration={500}>{t('buttons.beContacted')}</Link>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div className="col-lg-6 mt_md--30 mt_sm--30">
                                                                <div className="row row--15 mt_dec--30 service-wrapper">
                                                                    {dataList2.map( (val , i) => (     
                                                                        <div className="col-lg-12 col-md-6 col-sm-6 col-12 mt-5" key={i}>
                                                                            <div className="inner">
                                                                                <div className="image">
                                                                                    <Link to="/donations">
                                                                                        <img className="rounded" src={`${process.env.PUBLIC_URL + val.image}`} alt="card Images" />
                                                                                    </Link>
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    ))}
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </TabPanel>

                                            <TabPanel>
                                                <div className="rn-tab-content">
                                                    <div className="inner">
                                                        <div className="row align-items-center row--30">
                                                            <div className="col-lg-6">
                                                                <div className="section-title">
                                                                    <h4 className="title">{t('lePlan.epargneSalariale.title')}</h4>
                                                                    <p>{t('lePlan.epargneSalariale.content')}</p>
                                                                    <div className="read-more d-flex">
                                                                        <Link className="btn-default btn-small mr-2 co-btn" to="contactform" smooth={true} offset={-70} duration={500}>{t('buttons.beContacted')}</Link>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div className="col-lg-6 mt_md--30 mt_sm--30">
                                                                <div className="row row--15 mt_dec--30 service-wrapper">
                                                                    {dataList4.map( (val , i) => (     
                                                                        <div className="col-lg-12 col-md-6 col-sm-6 col-12 mt-5" key={i}>
                                                                            <div className="inner">
                                                                                <div className="image">
                                                                                    <Link to="/employee-savings">
                                                                                        <img className="rounded" src={`${process.env.PUBLIC_URL + val.image}`} alt="card Images" />
                                                                                    </Link>
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    ))}
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </TabPanel>

                                            <TabPanel>
                                                <div className="rn-tab-content">
                                                    <div className="inner">
                                                        <div className="row align-items-center row--30">
                                                            <div className="col-lg-6">
                                                                <div className="section-title">
                                                                    <h4 className="title">{t('lePlan.gestionPrimes.title')}</h4>
                                                                    <p>{t('lePlan.gestionPrimes.content')}</p>
                                                                    <div className="read-more d-flex">
                                                                        <Link className="btn-default btn-small mr-2 co-btn" to="contactform" smooth={true} offset={-70} duration={500}>{t('buttons.beContacted')}</Link>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div className="col-lg-6 mt_md--30 mt_sm--30">
                                                                <div className="row row--15 mt_dec--30 service-wrapper">
                                                                    {dataList5.map( (val , i) => (     
                                                                        <div className="col-lg-12 col-md-6 col-sm-6 col-12 mt-5" key={i}>
                                                                            <div className="inner">
                                                                                <div className="image">
                                                                                    <Link to="/bonus-reward">
                                                                                        <img className="rounded" src={`${process.env.PUBLIC_URL + val.image}`} alt="card Images" />
                                                                                    </Link>
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    ))}
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </TabPanel>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </Tabs>
                    </div>
                </div>
        </div>
    )
}

export default CoTabThree
